/* import __COLOCATED_TEMPLATE__ from './article.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const Article = templateOnlyComponent<Signature>();
export default Article;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::Article': typeof Article;
    'inbox2/conversation-stream/part-groups/article': typeof Article;
  }
}
